import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faClock,
    faDollarSign,
    faExchangeAlt,
    faMapMarkedAlt,
    faRoute,
    faSlidersH,
    faTruck
} from "@fortawesome/free-solid-svg-icons";

const RouteSettings = ({ routingType, stops, avoidOptions, selectedVehicle, hazmatOptions }) => {
    const from = stops?.[0]?.displayName || "--";
    const to = stops?.[stops.length - 1]?.displayName || "--";

    const SettingItem = ({ icon, label, value }) => (

		<li>
            <FontAwesomeIcon icon={icon}/>
            <strong>{label}:</strong>{" "}
            <span>{value}</span>
		</li>
    );

    const avoid = Object.entries(avoidOptions)
        .filter(([_, enabled]) => enabled)
        .map(([key]) => key.replace(/([A-Z])/g, " $1"))
        .join(", ") || "--";

    const vehicle = selectedVehicle?.value || {};
    const getVehicleDisplay = () => (
        `Vehicle type: Truck
Trailer Length: Single 53ft
Maximum Speed: --
Height: ${vehicle.height || "--"}"
Width: ${vehicle.width || "--"}"
Weight: ${vehicle.weight?.toLocaleString() || "--"} lbs
Axles: ${vehicle.axleCount || "--"}
Hazardous Material Type: ${
            hazmatOptions?.length
                ? hazmatOptions.map((h) => h.label).join(", ")
                : "--"
        }`
    );

    return (
        <div className="rounded-border">
            <h5>Route Settings</h5>

            <ul>
            {/*<div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr", // PDF-safe single column
                    gap: "12px"
                }}
            >*/}
                <SettingItem icon={faRoute} label="Routing type" value={routingType === "fastest" ? "Quickest" : routingType} />
                {/*<SettingItem icon={faMapMarkedAlt} label="Direction" value={`From: ${from}\nTo: ${to}`} />*/}

				<li>
		            <FontAwesomeIcon icon={faMapMarkedAlt}/>
        		    <strong>Direction:</strong>{" "}
            		<br/><span>From: {`${from}`}</span>            		
            		<br/><span>{`To: ${to}`}</span>
				</li>

                <SettingItem icon={faSlidersH} label="Configuration" value={`Avoid: ${avoid}`} />

				<li>
		            <FontAwesomeIcon icon={faTruck}/>
        		    <strong>Vehicle & Hazmat:</strong>{" "}

					<br/><span>Vehicle type: Truck</span>
					<br/><span>Trailer Length: Single 53ft</span>
					<br/><span>Maximum Speed: --</span>
					<br/><span>Height: {vehicle.height || "--"}"</span>
					<br/><span>Width: {vehicle.width || "--"}"</span>
					<br/><span>Weight: {vehicle.weight?.toLocaleString() || "--"} lbs</span>
					<br/><span>Axles: {vehicle.axleCount || "--"}</span>
					<br/><span>Hazardous Material Type: {
            			hazmatOptions?.length
                			? hazmatOptions.map((h) => h.label).join(", ")
                			: "--"
        				}</span>
				</li>

                {/*<SettingItem icon={faTruck} label="Vehicle & Hazmat" value={getVehicleDisplay()} />*/}
                <SettingItem icon={faClock} label="Departure" value="Not specified" />
                <SettingItem icon={faExchangeAlt} label="Exchange rate" value="--" />
                <SettingItem icon={faDollarSign} label="Guide" value="Guide 20" />
                <SettingItem icon={faDollarSign} label="Use transponder toll rates" value="True" />
            {/*</div>*/}
        	</ul>
        </div>
    );
};

export default RouteSettings;